import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Distributors from './components/Distributors';

const distributors = (props,{ t }) => (
  <Container>
    <Distributors {...props} />
  </Container>
);

distributors.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(distributors);
